import { render, staticRenderFns } from "./crownColorDropdown.vue?vue&type=template&id=2b440655&scoped=true&"
import script from "./crownColorDropdown.vue?vue&type=script&lang=js&"
export * from "./crownColorDropdown.vue?vue&type=script&lang=js&"
import style0 from "./crownColorDropdown.vue?vue&type=style&index=0&id=2b440655&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b440655",
  null
  
)

export default component.exports